import { PrismicProvider, PrismicToolbar } from "@prismicio/react";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";

import { client, repositoryName } from "./prismic";
import { HomePage } from "./pages/HomePage";
import { NotFound } from "./pages/NotFound";
import { Page } from "./pages/Page";
import { BlogLanding } from "./pages/BlogLanding";
import { Post } from "./pages/Post";
import { Preview } from "./pages/Preview";
import "./scss/osk.scss";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-96443022-1');
ReactGA.pageview(window.location.pathname + window.location.search);

export const App = () => {
  return (
    <PrismicProvider
      client={client}
      internalLinkComponent={({ href, ...props }) => (
        <Link to={href} {...props} />
      )}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/:uid" element={<Page />} />
          <Route path="/news-blog" element={<BlogLanding />} />
          <Route path="/news-blog/:uid" element={<Post />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <PrismicToolbar repositoryName={repositoryName} />
    </PrismicProvider>
  );
};
